import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "@/lib/site";
import { Reveal } from "@/components/motion/Reveal";

const Frame = ({ src, kind, label }) => (
  <div className="relative overflow-hidden rounded-2xl bg-ink/5 aspect-[4/3]">
    <img src={src} alt={`${label} ${kind}`} className="h-full w-full object-cover" loading="lazy" />
    <span
      className={`absolute top-3 left-3 rounded-full px-3 py-1 text-[11px] font-bold tracking-wider uppercase ${
        kind === "Before" ? "bg-ink/80 text-offwhite" : "bg-mustard text-ink"
      }`}
    >
      {kind}
    </span>
  </div>
);

export default function BeforeAfter() {
  return (
    <section id="before-after" className="relative py-20 md:py-32 bg-offwhite" data-testid="before-after-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-12">
        <Reveal className="max-w-2xl mb-14 md:mb-16">
          <p className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-petrol mb-4">Before & After</p>
          <h2 className="font-display font-extrabold text-ink text-3xl md:text-5xl tracking-tight leading-tight">
            Real Results, Real Homes.
          </h2>
          <p className="mt-4 text-ink/60 font-light text-base md:text-lg">
            See the difference our residential cleaning makes.
          </p>
        </Reveal>

        <div className="space-y-8 md:space-y-12">
          {IMAGES.beforeAfter.map((pair, i) => (
            <Reveal key={pair.label} delay={i * 0.1}>
              <motion.div
                whileHover={{ y: -4 }}
                transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                className="rounded-[28px] border border-ink/10 bg-white p-5 md:p-7 shadow-[0_10px_40px_rgba(22,52,69,0.06)]"
                data-testid={`ba-pair-${i}`}
              >
                <div className="flex items-center gap-3 mb-5">
                  <span className="h-2.5 w-2.5 rounded-full bg-mustard" />
                  <h3 className="font-display font-bold text-lg md:text-xl text-ink">{pair.label}</h3>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-[1fr_auto_1fr] items-center gap-4 sm:gap-5">
                  <Frame src={pair.before} kind="Before" label={pair.label} />
                  <div className="hidden sm:flex h-11 w-11 rounded-full bg-petrol items-center justify-center shrink-0 mx-auto">
                    <ArrowRight className="h-5 w-5 text-offwhite" strokeWidth={2.4} />
                  </div>
                  <Frame src={pair.after} kind="After" label={pair.label} />
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
